const ENTITY_ID_CASE_INSENSITIVE_REGEX = /^[A-Za-z]{2}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}$/

export const normalizeEntityId = (value: string): string => value.toUpperCase()

export const normalizeEntityIdParam = (value?: string | null): string | undefined => {
  if (!value) return undefined

  if (!ENTITY_ID_CASE_INSENSITIVE_REGEX.test(value)) return value

  return normalizeEntityId(value)
}

export const normalizeEntityIdsInPathname = (pathname: string): string =>
  pathname
    .split('/')
    .map((segment) => {
      if (!segment) return segment

      return normalizeEntityIdParam(segment) ?? segment
    })
    .join('/')
